module.exports = __webpack_public_path__ + "img/firewall-web.af0b347.svg";